import './About.css';

const About = () => {
    return (
        <div dir="rtl" className="about">

            {/* Section 1 – Text left, image right */}
            <div className="about-section">
                <div className="about-image">
                    <img src="../images/nature1.png" alt="נחל זורם" />
                </div>
                <div className="about-text">
                    <h2>קצת עלינו</h2>
                    <p>
                        אנחנו קבוצת סטודנטיות באוניברסיטה העברית שפיתחה את YallaGo –
                        אתר חברתי חדשני שמחבר בין אנשים שאוהבים לטייל ומחפשים פרטנרים עם תחומי עניין דומים.
                        <br />
                        ב-YallaGo לא צריך יותר לשבור את הראש את מי לגרור לטיול – אנחנו כבר נמצא לך את מי שיתאים בול.
                    </p>
                </div>
            </div>

            {/* Section 2 – Text right, image left */}
            <div className="about-section reverse">
                <div className="about-image">
                    <img src="../images/nature2.png" alt="שדה כלניות" />
                </div>
                <div className="about-text">
                    <h2>אז מה זה YallaGo?</h2>
                    <p>
                        YallaGo היא קהילה של מטיילים שמחפשים חוויות שמתאימות בדיוק להם.<br />
                        כבר בהרשמה תוכל למלא שאלון קצר שיעזור לנו להבין מי אתה ואיזה סוג טיולים מדברים אליך – טבע, עיר, אתגר או משהו רגוע יותר.<br />
                        לא מצאת טיול שמתאים לך? תוכל לפתוח טיול חדש ולחפש שותפים לפי ההעדפות שלך.<br />
                        האפליקציה תעזור לך למצוא את ההתאמות המדויקות – גם בטיול וגם באנשים.
                    </p>
                </div>
            </div>

            {/* Section 3 – List and paragraph */}
            <div className="about-section">
                <div className="about-image3">
                    <img src="../images/nature3.png" alt="ים המלח" />
                </div>
                <div className="about-text">
                    <h2>ב-YallaGo תוכל:</h2>
                    <p>
                        🧭 ליצור טיול חדש במקום בו אתה מעוניין ולטייל עם אנשים שמתאימים לך.<br />
                        🤝 להצטרף לקבוצות לפי תחומי עניין משותפים.<br />
                        🔍 לחפש טיולים פתוחים לפי מיקום, תאריך וסגנון.<br />
                        🎯 לקבל המלצות מותאמות אישית מ-AI.<br /><br />
                        בין אם בא לך על טיול רגוע עם אנשים זורמים, או אתגר בשטח עם חובבי ריצה – YallaGo תמצא לך את החברה הנכונה.
                    </p>
                </div>
            </div>

        </div>
    );
};

export default About;
